import { Navigation } from "@mui/icons-material";
import { Backdrop, Box, CircularProgress } from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Web3 from "web3";
import { initializeContract } from "../contract";
import { useAPIActions, useUIActions } from "../hooks/useActions";
import { useTypedSelector } from "../hooks/useTypedSelector";
import { checkForNavigation } from "../utils/wallet/apiHelpers";

const Layout = ({ children }) => {
  const { loading } = useTypedSelector((state) => state.uiReducer);
  const { account, chainId } = useWeb3React();
  const web3React = useWeb3React();
  const { pathname } = useLocation();

  const { setIsDataFetched } = useUIActions();

  const navigate = useNavigate();

  useEffect(() => {
    if (web3React.library) {
      initializeContract(web3React.library.currentProvider);
    }
  }, [web3React]);

  const {
    getNFTByUserAddress,
    setAccountBalance,
    resetAPIData,
    getAllUsers,
    setConnectedAccount,
    getClaimableNfts,
    getUserBorrowedNfts,
    fetchHoldings,
  } = useAPIActions();

  useEffect(() => {
    (async () => {
      if (account) {
        console.log("resetting and fetching data");
        await setIsDataFetched(false);
        if (pathname === "/scholar-details") {
          const isNavigationNeeded = await checkForNavigation(account);
          if (isNavigationNeeded) navigate("/");
        }
        await resetAPIData();
        await setConnectedAccount(account);
        // await setScholars(account, guildId);
        await setAccountBalance(account);

        await getAllUsers();
        await fetchHoldings(account, chainId);
        await getNFTByUserAddress(account, chainId);
        await getUserBorrowedNfts(account, chainId);
        await getClaimableNfts(account, chainId);
        await setIsDataFetched(true);
      }
    })();
  }, [account, chainId]);

  console.log("chainId", chainId);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Backdrop style={{ zIndex: 10000 }} open={loading} onClick={() => {}}>
        <CircularProgress style={{ color: "#F1C6FF" }} />
      </Backdrop>
      {children}
    </Box>
  );
};

export default Layout;
